import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { canLogEvents } from '@/utils/canLogEvents';

import { ProgressScreen } from './ProgressScreen';

export const ScreenProgress90: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Progress90',
      });
    }
  }, []);

  return (
    <ProgressScreen
      progress={90}
      startProgress={40}
      backgroundImage={`${S3_BUCKET_URL}/own-ai-compatibility/progress/progress-90.png`}
      topTitle="One step away from your perfect fantasy."
      mainTitle="Ready for the final touch?"
      subtitle=""
      buttonText="Continue"
    />
  );
};
